<template functional>
  <nav
    aria-label="Servicenavigation"
    class="footer-navigation"
  >
    <ul class="footer-navigation__list">
      <li>
        <a
          class="footer-navigation__link"
          href="https://li.hamburg.de/impressum"
          rel="noopener"
          target="_blank"
        >
          Impressum
        </a>
      </li>

      <li>
        <a
          class="footer-navigation__link"
          href="https://li.hamburg.de/datenschutz"
          rel="noopener"
          target="_blank"
        >
          Datenschutz
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'AFooterNavigation'
}
</script>

<style lang="scss" scoped>
.footer-navigation {
  margin-bottom: 1em;
}

.footer-navigation__list {
  list-style: none;

  margin: 0;
  padding: 1rem 0 0;
}

.footer-navigation__link {
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
